var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypagePersonalization = function SvgMypagePersonalization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    fillRule: "evenodd",
    d: "M11.25 10.5a4.5 4.5 0 1 0-.001-9.001 4.5 4.5 0 0 0 .001 9.001M6.07 21H19.5v-9H3v5.93A3.07 3.07 0 0 0 6.07 21",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    d: "M13.5 18.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "m18.576 16.982-1.768 1.768-.884-.884-.884.884.884.884.884.884.884-.884 1.768-1.768z"
  })));
};
export default SvgMypagePersonalization;